//React
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {toast} from 'react-toastify';

//Libs
import { Button, Icon } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";
import { useRouter } from "../../../../hooks/router";

//Components
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../components/Loader";
import Loading from "../../../../components/Loading";

//Styles
import {
  Container,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
  ButtonGroup,
} from "./styles";

const ListarCursos = () => {
  const [search, setSearch] = useState("");
  const [cursos, setCursos] = useState([]);
  const [page, setPage] = useState(1);
  const [isAtivos, setIsAtivos] = useState(true);
  const [loading, setLoading] = useState(false);
  const [launchedNotificationCoursesIDs, setLaunchedNotificationCoursesIDs] = useState([]);

  const router = useRouter();

  useEffect(() => {
    const type = router.pathname.split("/").pop();
    const isAtivos = type !== "inativos";

    setIsAtivos(isAtivos);
  }, [router]);

  useEffect(() => {
    loadCursoAtivo(1);
  }, [isAtivos]);

  const loadCursoAtivo = useCallback(
    async (page) => {
      const type = isAtivos ? "ativos" : "inativos";
      const ativo = isAtivos ? "S" : "N";

      setLoading(true);

      try {
        const params = {
          search,
          page,
          ativo,
        };

        const response = await api.get("curso", { params });

        setCursos(response.data);
        await systemLogs(`cursos/${type}`, `listou os cursos ${type}`);
        setLoading(false);
      } catch (err) {
        swal(`Não foi possível carregar os cursos ${type}`, err, "error");
        setLoading(false);
      }
    },
    [search, isAtivos]
  );

  const addPage = useCallback(async () => {
    const newPage = page + 1;

    setPage(newPage);
    await loadCursoAtivo(newPage);
  }, [page]);

  const removePage = useCallback(async () => {
    if (page <= 1) {
      return;
    }

    const newPage = page - 1;

    setPage(newPage);
    await loadCursoAtivo(newPage);
  }, [page]);

  const doSearch = useCallback(() => {
    loadCursoAtivo(page);
  }, [page, loadCursoAtivo]);

  const handleNotification = async ({courseID} = {}) => {
    try {
      await api.post(`admin/curso/${courseID}/notificacao`);
      setLaunchedNotificationCoursesIDs(prev => ([...prev, +courseID]));
      toast.success('Notificação enviada com sucesso');
    } catch(error) {
      toast.error('Houve um erro ao lançar notificação, verifique com TI');
    }
  }
  
  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Cursos {isAtivos ? "Ativos" : "Inativos"}</Title>
        <ContainerInputSearch>
          <Input
            type="text"
            placeholder="Pesquise pelo titulo"
            onChange={(e) => setSearch(e.target.value)}
            onKeyUp={(e) => e.key === "Enter" && doSearch()}
          />
          <Link>
            <Button onClick={doSearch}>
              <Icon name="search" />
            </Button>
          </Link>

          <Link to="/admin/cursos/criar">
            <Button>Criar</Button>
          </Link>
          <Link to="/admin/cursos/inativos">
            <Button>Buscar cursos Inativos</Button>
          </Link>
        </ContainerInputSearch>


        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell> Id </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Curso </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                {" "}
                Data e Hora de Inicio{" "}
              </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Cidade </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Valor </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Url </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Status </SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Observação</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell> Ação </SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body className="table-body">
            {loading ? (
              <Loading
                msg={
                  !search ? "Buscando cursos..." : `Buscando por ${search}...`
                }
              />
            ) : (
              cursos.map((curso) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{curso.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.curso}</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.data_sys}</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.cidade}</SemanticTable.Cell>
                  <SemanticTable.Cell>R${curso.valor},00</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.id_online}</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.status_curso}</SemanticTable.Cell>
                  <SemanticTable.Cell>{curso.obs}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <ButtonGroup>
                      <Button
                        icon="edit icon"
                        size="small"
                        color={"grey"}
                        onClick={() =>
                          window.open(`/admin/cursos/detalhes/${curso.id}`)
                        }
                      />
                      {(!curso?.hasLaunchedNotification && !launchedNotificationCoursesIDs?.includes(+curso.id)) && (
                        <Button
                          icon="bullhorn"
                          size="small"
                          color="orange"
                          basic
                          title="Emitir notificação lançamento"
                          onClick={() => handleNotification({courseID: curso.id})}
                        />
                      )}
                    </ButtonGroup>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))
            )}
          </SemanticTable.Body>
        </SemanticTable>
        {page > 1 && (
          <Button floated="left" onClick={removePage}>
            Voltar
          </Button>
        )}

        <Button floated="right" onClick={addPage}>
          Avançar
        </Button>
      </Content>
    </Container>
  );
};

export default ListarCursos;
